import {Yii} from "libraries/interfaces/Yii";

const CARD_LABELS = {
    modelsListCardHeader: Yii.t('wui-sasha-js', "Modèles d'email"),
    labelInputFilterField: Yii.t('wui-sasha-js', 'Filtrer la liste des modèles'),
    modelsList: Yii.t('wui-sasha-js', 'Liste des modèles'),
    chooseModel: Yii.t('wui-sasha-js', 'Choisir'),
    writeMessageWithoutTemplate: Yii.t('wui-sasha-js', 'Saisir un email sans modèle'),
    goBack: Yii.t('wui-sasha-js', 'Retour')
};

const LOADERS = {
    templatesLoading: Yii.t('wui-sasha-js', 'Chargement en cours')
};

const LIST = {
    choose: Yii.t('wui-sasha-js', 'Choisir')
};

export const WORDING = {
    ...CARD_LABELS,
    ...LOADERS,
    ...LIST
};